// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'cluster' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di cluster.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/cluster.sr-Cyrl-RS.meta.json.
import type { enUS } from './cluster'

export const srCyrlRS: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Гарантни приступи',
      subtitle: 'Сервисна врата чвора: приступ само за читање са привременом лозинком и хитни налог са лозинком из сефа',
      readOnlyTitle: 'Приступ само за читање (trantor)',
      stateNone: 'затворен',
      stateGranted: 'отворен',
      stateGrantedPending: 'одобрен — примењује се на чвору',
      grantedBy: 'Одобрио',
      grantedAt: 'Одобрено',
      expiresAt: 'Истиче',
      reason: 'Разлог',
      endedAt: 'Затворен',
      endedReason: {
        revoked: 'опозван',
        expired: 'истекао (TTL)',
        reboot: 'поновно покретање чвора',
        failed: 'није примењен (задатак није успео)'
      },
      grant: 'Одобри приступ само за читање…',
      grantTitle: 'Одобри приступ само за читање',
      grantSubmit: 'Одобри',
      grantError: 'Одобрење је одбијено',
      grantConfirm: 'TVirt генерише привремену лозинку за системског корисника «trantor» (само читање: јоурнал и дијагностика, без sudo) и поставља је на чвору задатком. Лозинка се приказује САМО једном, при потврди; престаје истеком, опозивом или при следећем поновном покретању чвора.',
      reasonLabel: 'Разлог',
      reasonHint: 'Зашто отварате врата: остаје у одобрењу, у ревизији и у дневнику',
      ttlLabel: 'Трајање',
      ttlHours: '{n} х',
      revoke: 'Опозови приступ само за читање…',
      revokeTitle: 'Опозови приступ само за читање',
      revokeSubmit: 'Опозови',
      revokeError: 'Опозив је одбијен',
      revokeConfirm: 'Одобрење престаје одмах и задатак поново закључава корисника «trantor» на чвору: привремена лозинка престаје да важи.',
      passwordTitle: 'Лозинка само за читање',
      passwordOnce: 'Ова лозинка се приказује САМО једном: копирајте је сада. Нигде се не чува и неће моћи поново да се прочита — ако је изгубите, одобрите поново.',
      passwordUser: 'Корисник',
      passwordLabel: 'Лозинка',
      passwordHint: 'Важи до {until} или до следећег поновног покретања чвора; употребљива када је задатак одобрења завршен. Приступ: ссх trantor@<adresa čvora>.',
      emergencyTitle: 'Последњи хитни приступ (trantor-emergency)',
      lastLogin: '{time} путем {via} са {from}',
      lastLoginNone: 'ништа забележено',
      lastLoginVia: {
        ssh: 'ссх',
        console: 'конзола',
        sudo: 'sudo',
        unknown: 'непознато'
      },
      emergencyHint: 'Хитни налог «trantor-emergency» (пуни sudo) увек је омогућен са лозинком генерисаном при инсталацији чвора и чуваном у сефу: TVirt је не зна, не ротира и не обнавља. Свака пријава се пријављује овде и у дневнику догађаја.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall чворова',
      subtitle: 'Постура нфтаблес рулесета који сваки чвор примењује на себе — једини firewall једног чвора (firewalld је онемогућен)',
      modeLabel: 'Постура',
      mode: {
        disabled: 'Онемогућен — нема рулесета на чворовима',
        permissive: 'Пермисиван — броји и бележи, ништа не одбацује',
        enforced: 'Примењен — улази само изведени регистар'
      },
      hint: {
        disabled: 'Као данас: чворови не носе никакав рулесет. Пређите на пермисиван да PROČITATE шта би било одбачено пре него што буде одбачено.',
        permissive: 'Сваки чвор примењује свој изведени рулесет уз policy аццепт: оно што би примењени режим одбацио броји се и бележи (јоурнал префикс «tvirt-node would-drop:»). Ништа се не блокира.',
        enforced: 'Сваки чвор примењује свој изведени рулесет уз policy дроп: ссх и API одасвуд, store / live migration / overlay / Ceph само од чланова, listeneri мрежних сервиса из мреже коју опслужују. Свака промена је apply уз потврду — чвор који не успе да потврди сам се враћа назад.'
      },
      confirmTitle: 'Применити firewall чворова?',
      confirmBody: 'Сваки чвор примењује рулесет уз потврду: сондира backend, store и ссх кроз нова правила у року и потврђује — иначе се сам враћа на претходни рулесет. Прво прочитајте бројаче пермисивног режима на чворовима.',
      confirmSubmit: 'Примени',
      confirmCancel: 'Откажи',
      lensTitle: 'Firewall чвора',
      loadError: 'Није могуће учитати сочиво firewalla чвора',
      noReport: 'Још нема firewall извештаја са овог чвора — worker извештава при следећем пролазу',
      firewalldActive: 'На овом чвору ради firewalld: firewall чвора одбија да се примени поред њега (маскирајте firewalld)',
      conditionUnconfirmed: 'Још нема потврђеног рулесета — чвор је отворен',
      conditionRolledBack: 'Последњи apply се вратио назад — иста генерација се не покушава поново док се регистар не промени или се постура поново не промени',
      lastError: 'Последња грешка',
      posture: 'Постура',
      observedAt: 'Посматрано',
      desiredGeneration: 'Жељена генерација',
      componentTitle: 'Компонента чвора',
      componentSubtitle: 'tvirt-node-firewall — при boot-u примењује потврђени рулесет, непотврђени сам враћа назад',
      componentAbsent: 'Компонента још није известила',
      phase: 'Фаза',
      phases: {
        none: 'Никад примењен',
        applied: 'Примењен — чека потврду',
        confirmed: 'Потврђен',
        rolledBack: 'Враћен назад'
      },
      generation: 'Генерација',
      appliedAt: 'Примењено',
      confirmedAt: 'Потврђено',
      deadline: 'Рок за rollback',
      lastRollback: 'Последњи rollback',
      registryTitle: 'Изведени регистар',
      registrySubtitle: 'Портови које овај чвор отвара, по класи и пореклу — изведени из кластера, никад ручно мењани',
      registryEmpty: 'Ништа није изведено — постура онемогућена без потврђеног рулесета, или још нема извештаја',
      colClass: 'Класа',
      colPort: 'Порт',
      colSource: 'Извор',
      colOrigin: 'Порекло',
      classes: {
        public: 'Јавна',
        internode: 'Међучворна',
        tenant: 'Тенант'
      },
      sourceMembers: 'само чланови',
      sourceAnywhere: 'одасвуд',
      sourceBridge: 'на {iface}'
    },
    derivationDerived: 'изведен',
    derivationDiverged: 'одступљен',
    derivationDerivedTip: 'Мрежни документ је IZVEDEN из fabrica {fabric} и још се поклапа са рендером на тренутним улазима — клик за план деривације.',
    derivationDivergedTip: 'Деривација из fabrica {fabric} променила се после задњег apply-a (fabric, ожичење, улоге или референце) — клик за чекајући дифф.',
    derivationRetiring: {
      one: '{n} адреса се празни',
      few: '{n} адресе се празне',
      other: '{n} адреса се празни'
    },
    standaloneHint: 'Овај чвор нема кластер: још није инсталиран. Кластери се креирају ИЛИ им се приступа при инсталацији — join токен генерисан из табеле Сервери једног члана даје се installeru (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Ваше дозволе покривају један scope, не цео кластер: инвентар флоте — чворови, подешавања и уређаји — видљив је само администраторима кластера.',
    phaseReady: 'Спреман',
    phaseForming: 'У формирању',
    storeMembers: 'Чланови storea',
    watermark: 'Праг конвергенције',
    configGeneration: 'Цонфиг генерација',
    converged: 'усклађено',
    behind: 'заостаје — {m} / {n}',
    revision: 'Ревизија',
    rolesTitle: 'Мрежне улоге',
    rolesSubtitle: 'Адресе по члану за сваку класу саобраћаја — сама конективност живи у хост мрежи',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'наслеђује management',
    settingsTitle: 'Подешавања',
    settingsSubtitle: 'Безбедносна policy на нивоу кластера — сваки чвор је процењује из своје локалне реплике',
    taskRetentionTitle: 'Ретенција задатака',
    taskRetentionSubtitle: 'Обједињени GC за све задатке — завршени задаци преко старосне границе или лимита се сакупљају, они у току никада',
    taskRetentionMaxAge: 'Максимална старост (дани)',
    taskRetentionMaxCount: 'Максималан број задатака',
    eventRetentionTitle: 'Задржавање догађаја',
    eventRetentionSubtitle: 'GC дневника — политика независна од оне задатака: задатак је ред, догађај је меморија',
    eventRetentionMaxAge: 'Највећа старост (дани)',
    eventRetentionMaxCount: 'Највећи број догађаја',
    spaceThresholdsTitle: 'Прагови простора',
    spaceThresholdsSubtitle: 'Када складиште које се пуни доспе у дневник (и обавештења)',
    spaceLowPct: 'Упозорење од (% искоришћено)',
    spaceCriticalPct: 'Критично од (% искоришћено)',
    spaceOrderError: 'Критично не може бити испод упозорења',
    spaceThresholdsHint: 'Конфигуришу се само улази: излаз изводи мотор, 5 поена испод сваког прага, да складиште на линији никада не постане метроном',
    failoverReserveTitle: 'Failover резерва',
    failoverReserveSubtitle: 'Admission control N+1 — RAM који се држи слободним да би кластер могао да рестартује своје оптерећење после губитка чворова',
    failoverReserveTolerate: 'Број чворова чији се губитак толерише',
    failoverReserveOff: '0 — резерва је искључена: ниједно покретање се никада не одбија због failover капацитета',
    failoverReserveOn: 'Покретање које би начело резерву одбија се уз 412 који објашњава бројеве',
    networkShapingTitle: 'Праведност пропусног опсега',
    networkShapingSubtitle: 'Три типолошке тежине схапинг стабла по уплинк-у — делују само под надметањем',
    networkShapingRest: 'Тежина остатка (управљачка раван, storage, реплике)',
    networkShapingOverlay: 'Тежина overlay мрежа',
    networkShapingLiveMigration: 'Тежина live миграције',
    networkShapingHint: 'Загарантовани удео = тежина / збир три (подразумевано 300 / 100 / 200, свака од 1 до 10000); на слободној вези свака класа може узети цео опсег',
    debugModeTitle: 'Дебуг режим',
    debugModeSubtitle:
      'Детаљне грешке у генеричким упозорењима GUI-ја — да се види прави узрок када је „неуспешна“ акција заправо успела',
    debugModeLabel: 'Дебуг режим омогућен',
    debugModeOn: 'Генеричка упозорења о грешци додају на крај узрок у позадини — интерни детаљи видљиви сваком оператеру',
    debugModeOffHint: 'Искључен — генеричка упозорења о грешци остају генеричка, без интерних детаља',
    nodeDetailsAction: 'Детаљи чвора',
    node: {
      docTitle: 'Чвор',
      notFound: 'Чвор није пронађен',
      tabOverview: 'Преглед',
      tabStats: 'Статистика',
      tabNetwork: 'Мрежа',
      tabSettings: 'Локална подешавања',
      identityTitle: 'Идентитет',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL порт',
      revision: 'Цонфиг ревизија',
      versionsTitle: 'Посматране верзије',
      heartbeatSubtitle: 'Последње стање које је чвор пријавио о себи',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU модел',
      memoryTitle: 'Меморија',
      hugePagesTitle: 'Огромне странице',
      hugePagesPool: '{size}: слободно {free} од {total}',
      hugePagesNone: 'Нема poola',
      hugePagesNoneHint: 'Чвор нема резервисане огромне странице: VM-ови који их траже не могу овде да се покрену. Pool се декларише на чвору, кернел параметрима hugepagesz и hugepages или уписом nr_hugepages.',
      usageTitle: 'Тренутна употреба',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'није посматрано — нема свежег узорка',
      statsNoData: 'Нема података у изабраном опсегу — серије чвора узоркује сам чвор и служи их локално.',
      observedTitle: 'Посматрано стање',
      observedSubtitle: 'Сервиси и асети локални за чвор, како их види worker'
    },
    editRolesTitle: 'Измените мрежне улоге',
    memberNode: 'Чвор',
    memberIp: 'IP адреса',
    addMember: 'Додај члана',
    lmInherit: 'Користи management адресе',
    roleIpHint: 'Додавање и уклањање чланова је слободно; измена IP-а постојећег члана на лицу места се одбија — ток IP миграције стиже у каснијој рунди.',
    roleError: 'Улоге није могуће ажурирати',
    nodesTitle: 'Чворови',
    addNodeTitle: 'Додајте чвор у кластер',
    addNode: 'Додај чвор',
    addNodeError: 'Чвор није могуће предрегистровати',
    nodeName: 'Име чвора',
    nodeNameHint: 'мора се поклапати са именом изабраним при инсталацији',
    nodeIp: 'Management IP',
    colName: 'Име',
    colPhase: 'Фаза',
    colServices: 'Сервиси',
    colWatermark: 'Watermark',
    colLastSeen: 'Последњи контакт',
    colUps: 'UPS',
    upsCordonChip: 'UPS кордон',
    upsCordonTip: 'Чвор се осудио на основу чињеница свог UPS-а ({time}): сам уклања кордон кад мрежа постане стабилна, а батерија напуњена',
    upsUnreachable: 'UPS недоступан',
    upsOnBattery: 'На батерији',
    upsOnLine: 'На мрежи',
    upsLowBattery: 'слаба батерија',
    upsNoEstimateChip: 'аутономија није процењена',
    upsNoEstimateTip: 'UPS не објављује процену аутономије: чвор се осуђује само LB заставицом (слаба батерија) UPS-а — подесите battery.runtime.low / LB на самом UPS-у',
    upsLaneTip: 'UPS пут гашења од {since}: осуђен због {by}',
    upsUnit: 'јединица',
    upsStatus: 'NUT стање',
    upsLoad: 'оптерећење',
    upsOnBatterySince: 'на батерији од',
    upsOnLineSince: 'на мрежи од',
    upsError: 'грешка',
    upsObservedAt: 'посматрано',
    upsNone: 'ниједна UPS јединица не опслужује овај чвор',
    upsBy: {
      runtime: 'аутономија испод прага',
      lowBattery: 'LB заставица UPS-а',
    },
    upsLane: {
      evacuate: 'евакуација',
      local: 'гашење на месту',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'заустављање гостију',
      stoppingServices: 'заустављање сервиса',
      poweredOff: 'угашен',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS јединице и прагови: чвор осуђен при аутономији ≤ праг или LB заставици (увек поштована), наставак са хистерезом',
    upsRuntimeThreshold: 'Праг аутономије (с)',
    upsRuntimeThresholdHint: 'На батерији, са процењеном аутономијом ≤ праг чвор се гаси по реду (подразумевано 300)',
    upsResumeStable: 'Мрежа стабилна током (с)',
    upsResumeStableHint: 'Наставак само уз непрекинуту мрежу најмање толико секунди (подразумевано 60)',
    upsResumeCharge: 'Минимална напуњеност при наставку (%)',
    upsResumeChargeHint: 'И батерија напуњена бар до овог процента (подразумевано 25)',
    upsPolicyNote: 'LB заставица (слаба батерија) UPS-а увек осуђује и не може се искључити; не постоји праг на време проведено на батерији. Свака јединица може преписати та три броја.',
    upsUnitNew: 'нова јединица',
    upsUnitSelectors: '{n} селектор(а) по ознакама (само CLI)',
    upsUnitName: 'Назив јединице',
    upsUnitMode: 'Режим',
    upsModeExternal: 'спољна (туђи упсд)',
    upsModeManaged: 'управљана (UPS повезан на чвор)',
    upsUnitUpsname: 'NUT назив (упснаме)',
    upsUnitHost: 'упсд хост',
    upsUnitAttachedNode: 'Повезани чвор',
    upsUnitDriver: 'NUT драјвер',
    upsUnitDriverHint: 'усбхид-упс, nutdrv_qx, снмп-упс, …',
    upsUnitDevice: 'Уређај драјвера',
    upsUnitDeviceHint: 'ред port= у ups.conf: празно = ауто',
    upsUnitPort: 'упсд порт',
    upsUnitServedNodes: 'Опслуживани чворови',
    upsUnitServedNodesHint: 'називи чворова одвојени зарезима (селектори по ознакама иду кроз CLI)',
    upsUnitOverrideHint: 'празно = подразумевано кластера',
    upsUnitAdd: 'Додај јединицу',
    unreachableSince: 'Недоступан — последњи heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane још није реализовао текућу overlay конфигурацију',
    overlaysError: 'Последњи пролаз overlay усаглашавања неуспешан: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Чека join',
      'joining': 'Приступа',
      'member': 'Члан'
    },
    tokenTitle: 'Join токен',
    tokenOnce: 'Приказан само сада — одмах га копирајте, више неће моћи да се прочита',
    copy: 'Копирај',
    copied: 'Копирано',
    close: 'Затвори',
    revokeTitle: 'Опозовите предрегистрацију',
    revoke: 'Опозови',
    revokeError: 'Регистрацију није могуће опозвати',
    promote: 'Унапреди у store member',
    demote: 'Уклони улогу store-member',
    troubleshoot: 'Решавање проблема',
    promoteTitle: 'Унапредите у store member',
    demoteTitle: 'Уклоните улогу store-member',
    promoteHint: 'Чвор улази у кворум YugabyteDB мастера. Права HA захтева три store membera.',
    demoteHint: 'Чвор излази из кворума мастера и зауставља своје store сервисе.',
    storeError: 'Измена store-membera је одбијена',
    attest: 'Атестирај као угашен…',
    attestTitle: 'Атестирајте чвор као угашен',
    attestSubmit: 'Атестирај као угашен',
    attestConfirm: 'Проглашавате овај чвор угашеним, на сопствени ризик: атестирати чвор који је у ствари жив ризикује двоструко извршавање VM-ова. Његови задаци се обележавају као неуспешни, а authority његових VM-ова постају преносиви.',
    attestError: 'Атестација је одбијена',
    attestedChip: 'атестиран као угашен',
    maintenanceChip: 'одржавање',
    guestToolsChip: 'TVirt Guest Tools (ISO асет локалан за чвор)',
    maintenanceEnter: 'Укључи одржавање',
    maintenanceExit: 'Искључи одржавање',
    maintenanceEnterTitle: 'Укључите одржавање',
    maintenanceExitTitle: 'Искључите одржавање',
    maintenanceEnterSubmit: 'Укључи одржавање',
    maintenanceExitSubmit: 'Искључи одржавање',
    maintenanceEnterConfirm: 'Чвор се ставља у кордон и празни: мрежне услуге и App instance чији authority држи преносе се (instance на хладно: заустављене и пожњевене овде, поново створене на одредишном чвору — прекид), покренуте VM мигрирају се уживо где је могуће, иначе се уредно заустављају, задаци у току се завршавају, нови посао чека, а заустављене VM губе свој authority — Proximity их поново смешта при следећем покретању. Ништа се не враћа само на крају одржавања.',
    maintenanceExitConfirm: 'Чвор поново преузима посао и Proximity га опет узима у обзир за распоређивање. VM-ови се враћају само када се покрену.',
    maintenanceError: 'Захтев за одржавање је одбијен',
    maintenancePlanTitle: 'План евакуације',
    maintenancePlanLoading: 'Израчунавање плана евакуације…',
    maintenancePlanError: 'План евакуације није могуће учитати — drain ће свеједно мигрирати где је могуће и зауставити остало.',
    maintenancePlanEmpty: 'На овом чвору нема шта да се евакуише — нема активне мрежне услуге, нема App instance која се жели покренута, нема покренуте VM.',
    maintenancePlanSummary: '{migrate} објеката ће мигрирати (VM, мрежне услуге, App instance), {stop} ће се зауставити или остати где јесу.',
    maintenancePlanReserve_ok: 'Failover резерва после пражњења: нетакнута — остаје {headroom} GiB за покретање док се толерише губитак чворова: {n}.',
    maintenancePlanReserve_eroded: 'Failover резерва после пражњења: скоро потрошена — остаје само {headroom} GiB од {reserve} GiB који се држе слободним за отказе чворова: {n}.',
    maintenancePlanReserve_exhausted: 'Failover резерва после пражњења: ИСЦРПЉЕНА — недостаје {headroom} GiB од {reserve} GiB потребних да се толеришу откази чворова: {n}. Док је овај чвор ван, нова покретања VM-ова биће одбијана.',
    maintenancePlanReserve_unknown: 'Failover резерва после пражњења: не може се израчунати — ниједан преостали чвор није пријавио своју меморију.',
    maintenancePlanReserveHugePages: 'Огромне странице од {size} после пражњења — слободно: {free} од {capacity}, потребно као резерва: {reserve}.',
    maintenancePlanActionMigrate: 'мигрира',
    maintenancePlanActionMigrateWarning: 'мигрира (soft правило прекршено)',
    maintenancePlanActionStop: 'зауставља се',
    maintenancePlanActionBlocked: 'блокиран',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'мрежна услуга',
    maintenancePlanKindApp: 'App инстанца',
    maintenancePlanColdMove: 'Премештање на хладно: под се овде зауставља и жање, а одредишни worker га поново ствара — прекид до следећег пасс-а одредишног worker-a.',
    caFingerprint: 'Fingerprint CA кластера',
    staleChip: 'застарело',
    troubleshootTitle: 'Решавање проблема са storeom',
    restartStore: 'Рестартуј store сервисе',
    restartHint: 'Ако се store понаша чудно, рестартујте његове сервисе. Напредно — користити опрезно.',
    restartQueued: 'Задатак рестартовања у реду чекања',
    restartError: 'Сервисе није могуће рестартовати',
    svcActive: 'активан',
    svcWanted: 'жељен, није активан',
    svcStopped: 'заустављен',
    noServices: 'Ниједан сервис није пријављен'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'GPU инвентар целог кластера груписан по моделу — посматране картице по чвору, са маркираним регистрацијама и њиховим таговима',
    usbTitle: 'USB ресурси',
    usbSubtitle: 'USB инвентар целог кластера груписан по моделу — посматрани уређаји по чвору, са регистрацијама оба модела (по уређају, по порту) и њиховим таговима',
    markedChip: 'употребљивих за TVirt: {n}',
    orphanChipGpu: 'напуштених: {n}',
    orphanChipUsb: 'напуштених: {n}',
    colNode: 'Чвор',
    colRegistration: 'Регистрација',
    noRegsHint: 'Нема регистрација — уређај се маркира као „употребљив за TVirt“ из дијалога чвора (Чворови › чвор › Подешавања).',
    colDevice: 'Уређај',
    colObserved: 'Посматрани',
    colRegs: 'Регистрације',
    regsNone: 'ниједна',
    colPci: 'PCIe адреса',
    colIdentity: 'Идентитет / порт',
    colClasses: 'Класе (тагови)',
    colActions: 'Акције',
    manageOnNode: 'Управљај на чвору {node} (маркирање живи у дијалогу чвора)',
    introTitle: 'Кластерски инвентар USB и PCIe уређаја употребљивих за TVirt©.',
    introStep1: '1. Чворови сами откривају своје GPU-ове и USB уређаје (попис у heartbeatu).',
    introStep2: '2. Уређај се маркира као „употребљив за TVirt“ из дијалога ЧВОРА (Чворови › чвор › Подешавања) — маркирање га везује за vfio и региструје га овде.',
    introStep3: '3. Овде регистрацијама дајете њихове КЛАСЕ преко тагова (нпр. gpu_class=compute): захтеви VM-ова тражиће класу, а scheduler ће изабрати чвор са слободним одговарајућим уређајем.',
    colMode: 'Режим',
    colState: 'Стање',
    colNotes: 'Белешке',
    colTags: 'Тагови',
    modeDevice: 'по уређају',
    modePort: 'по порту',
    usable: 'употребљив',
    orphanGpu: 'напуштена',
    orphanUsb: 'напуштен',
    hubChip: 'hub',
    orphanPortsTitle: 'Регистрације по порту без прикаченог уређаја — поново прикачите уређај или им на чвору поништите маркирање',
    gpusEmpty: 'Ниједан GPU још није посматран ни на једном чвору',
    usbEmpty: 'Ниједан USB уређај још није посматран ни на једном чвору'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Минимална дужина лозинке',
    sessionIdle: 'Timeout неактивности сесије (минути)',
    lockoutThreshold: 'Закључавање после неуспешних покушаја',
    lockoutDuration: 'Трајање закључавања (минути)',
    keyboardLayout: 'Распоред тастатуре',
    keyboardLayoutHint: 'нпр. it, en-us — празно за подразумевани QEMU',
    syslogEndpoint: 'Syslog endpoint',
    syslogEndpointHint: 'хост:порт — празно да се прослеђивање онемогући',
    syslogTls: 'TLS',
    maxQueued: 'Максимум задатака у реду чекања',
    concurrency: 'Конкурентност workera',
    concurrencyHint: 'Worker је примењује у ходу',
    notesTitle: 'Белешке',
    save: 'Сачувај',
    saved: 'Подешавања сачувана',
    saveError: 'Подешавања није могуће сачувати'
  },
  localSettings: {
    derivedChip: 'изведен',
    derivedTip: 'Овај device је у VLASNIŠTVU деривације fabrica (H2): editor одбија да га dira — измените fabric (или ожичење) и поново примените, или га узмите назад испод.',
    takeOwnership: 'Преузми власништво',
    takeOwnershipTitle: 'Преузми власништво (take-ownership)',
    takeOwnershipConfirm: '{name} напушта fabric блок и поново постаје RUČNI device којим управља овај editor. Чвор постаје одступљен, а следећи apply деривације на њему ће одбити (manualConflict) док га не преименујете или уклоните — или не исправите fabric.',
    nodeSettingsTitle: 'Подешавања чвора',
    nodeSettingsSubtitle: 'Оно што овај чвор спроводи — ред задатака, конзола, прослеђивање logova — плус његови тагови и белешке',
    baseTitle: 'Хост резерве (TVirt Proximity)',
    baseSubtitle: 'CPU и RAM резервисани за оперативни систем хоста — улази емпиријског капацитета по ком Proximity распоређује VM-ове',
    baseMemory: 'Базни RAM (MiB)',
    baseMemoryHint: 'Посматрано укупно: {total} MiB. Употребљиво за VM-ове = укупно − база − RAM упаљених VM-ова распоређених овде.',
    baseMemoryHintNoTotal: 'Употребљиво за VM-ове = посматрано укупно − база − RAM упаљених VM-ова распоређених овде.',
    baseCpu: 'Базна CPU језгра',
    baseCpuHint: 'Посматрани логички CPU-ови: {total}. Користи се само као тежина за рангирање — vCPU overcommit је нормалан.',
    baseCpuHintNoTotal: 'Користи се само као тежина за рангирање — vCPU overcommit је нормалан.',
    baseHint: 'RAM је тврда капија пријема: VM који не стаје у употребљиви RAM одбија се уз речиту грешку. Повећајте базу на хостовима који држе чланове storea или Ceph демоне.',
    placementTitle: 'Физички смештај',
    placementSubtitle: 'Где овај сервер физички стоји — декларисано једном, чему год служио',
    placementHint: 'Смештај води CRUSH хијерархију сваког Ceph кластера са OSD-ом на овом серверу: чување измене поново поравнава њихове мапе кроз задатак (хост → rack → … → root). Делимичне декларације су легалне — празни нивои се просто урушавају. Имена су дељена преко целе мапе: два сервера у истом racku декларишу исто име racka.',
    placementNameInvalid: 'DNS-safe име (мала слова, цифре, цртице)',
    placementEmpty: 'Празно = није декларисано',
    placementLevel: {
      chassis: 'Шасија',
      rack: 'Rack',
      row: 'Ред',
      pdu: 'PDU',
      pod: 'Под',
      room: 'Просторија',
      datacenter: 'Datacenter',
      zone: 'Зона',
      region: 'Регион'
    },
    cablingTitle: 'Каблирање',
    cablingSubtitle: 'У који switch порт је утакнут сваки интерфејс — декларација живи на чвору (Annex О.9)',
    cablingHint: 'Један кабл по NIC-у, један кабл по порту на целој флоти (API одбија именујући носиоца). Каблирање ка порту који је члан LAGG-а је легално — то је bond случај: будућа деривација ће га извести као LACP.',
    cablingInterface: 'Интерфејс',
    cablingNotCabled: '— није каблирано —',
    cablingNoInterfaces: 'Ниједан мрежни интерфејс још није посматран',
    disksTitle: 'Дискови',
    disksSubtitle: 'Посматрани блок уређаји — једно скенирање по пролазу усаглашавања; овде маркирајте дискове употребљиве као Ceph OSD-ови (N.15: подобност је експлицитна)',
    colDataDisk: 'Диск за податке',
    dataDisksHint: 'Штиклирање уређаја декларише га као употребљивог за OSD; серијски број је његов идентитетски pin — копиран из хардвера када га диск пријави, искован (tvirt-…) у супротном. Ceph дијалог за регистрацију нуди само декларисане дискове.',
    diskDeclaredSerial: 'декларисан',
    diskNotObserved: 'декларисан, али није посматран — поново прикачите уређај или уклоните штиклу',
    noDisks: 'Ниједан блок уређај још није посматран',
    colSerial: 'Серијски број',
    colModel: 'Модел',
    colSize: 'Величина (GiB)',
    colDiskType: 'Тип',
    colInUse: 'У употреби',
    colObservedAt: 'Посматран',
    diskInUse: 'у употреби',
    diskFree: 'слободан',
    diskMounted: 'монтиран',
    diskPartitions: 'партиције',
    passthroughTitle: 'Passthrough уређаји',
    passthroughSubtitle: 'Посматрани GPU-ови и USB уређаји — овде маркирајте шта TVirt сме да проследи VM-овима; маркирање региструје идентитет уређаја (round U1+G1)',
    passthroughHint: 'Маркирање региструје уређај (стабилан ид — meta тагова и класних захтева). Маркирани GPU има ЦЕЛУ IOMMU групу везану за vfio-pci одједном — одмах напушта хост; поништавање маркирања поново везује нативни driver. За USB постоје оба ратификована модела: по уређају (vendor+proizvod, где год да је прикачен) и по физичком порту (VM добија шта год је ту утакнуто). USB се не везује при маркирању — attach се дешава у рунтимеу VM-а.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Употребљив за TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI адреса',
    colDriver: 'Driver',
    colVerdict: 'Вердикт',
    gpuEligible: 'Подобан',
    gpuIneligible: 'Неподобан',
    gpuReason: {
      'no-iommu': 'IOMMU није активан на хосту',
      'group-spans-slots': 'IOMMU група није изолована: простире се преко других slotova',
      'multiple-display': 'IOMMU група није изолована: више од једне видео функције',
      'foreign-function': 'IOMMU група није изолована: садржи страну функцију'
    },
    vfioNotReady: 'IOMMU није активан на овом хосту: ниједан GPU није подобан док га хост платформа не омогући (OEM ISO) — TVirt никада не dira кернел args у рунтимеу.',
    vfioMissingKernelArg: 'IOMMU није активан на овом хосту: firmware пријављује VT-d/AMD-Ви (ACPI DMAR/IVRS табела постоји), али недостаје кернел arg — додајте intel_iommu=on (Intel) или уклоните amd_iommu=off (AMD) са кернел командне линије и рестартујте. TVirt никада не dira кернел args у рунтимеу.',
    vfioFirmwareDisabled: 'IOMMU није активан на овом хосту: VT-d/AMD-Ви је онемогућен у firmwareu (нема ACPI DMAR/IVRS табеле) или га CPU не подржава — омогућите га у firmware подешавањима, ниједан кернел arg не може да га укључи. TVirt никада не dira хост у рунтимеу.',
    gpuBindError: 'vfio-pci bind неуспешан на {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Firewall на неуправљаним bridgeovima',
    firewallBridgesSubtitle: 'Ручно изграђени bridgeovi на овом чвору чији сетуп пристаје на firewall цхаинове које TVirt рендерује на прикаченим guest NIC-овима',
    firewallBridgesHint: 'TVirt никада не dira туђи bridge — цхаин се сидри на тап/ветх, који је увек TVirtov. Листа је капија пристанка: default-deny и анти-спооф могу да сломе оно што ручни сетуп очекује, па се NIC са firewallom на неуправљаном bridgeu који НИЈЕ овде наведен одбија уз речиту грешку.',
    firewallBridgesEmpty: 'Ниједан неуправљани bridge на овом чвору не пристаје на firewall цхаинове које TVirt рендерује.',
    firewallBridgeAdd: 'Додај bridge',
    firewallBridgeInvalid: 'Није име Linux интерфејса (1-15 знакова, без косе црте и размака)',
    firewallBridgeDuplicate: 'Име је већ на списку',
    colMarkDevice: 'По уређају',
    colMarkPort: 'По порту',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Порт',
    passthroughOrphan: 'напуштен — регистрован, али се више не детектује: поново га прикачите или му поништите маркирање',
    noGpus: 'Ниједан GPU још није посматран',
    noUsb: 'Ниједан USB уређај још није посматран',
    networkGeneration: 'Мрежна генерација',
    applied: 'Примењена',
    converged: 'усклађено',
    behind: 'заостаје — {m} / {n}',
    notConfigured: 'није конфигурисано',
    rollbackBody: 'Примена генерације {gen} неуспешна: {error}',
    rolledBackChip: 'rollback извршен',
    nicsTitle: 'NIC-ови',
    nicsSubtitle: 'Матични подаци управљаних NIC-ова — регистрација ЈЕСТЕ декларација управљања: регистровани NIC без конфигурације се не dira (clear-if га експлицитно декларише чистим), нерегистрован уређај се никада не dira',
    addNic: 'Региструј NIC',
    addNicTitle: 'Региструјте NIC (add-nic)',
    delNic: 'Окончај управљање',
    delNicTitle: 'Окончајте управљање (del-nic)',
    delNicConfirm: 'Управљање уређајем {name} се окончава: ставка матичних података и њена конфигурација се бришу, а TVirt профил се уклања — сам уређај остаје онакав каквим га Linux држи.',
    nicName: 'Име уређаја',
    nicMac: 'Трајна MAC адреса',
    nicMacHint: 'трајни хардверски MAC — стабилни идентитет који поставља TVirt Сервер Installer',
    colObserved: 'Посматран',
    nicObserved: 'посматран',
    nicNotObserved: 'није посматран',
    nicMacMismatch: 'MAC се не поклапа — посматран {mac}',
    noNics: 'Ниједан NIC није регистрован — региструјте уређај да бисте почели да њиме управљате',
    noManagedDevices: 'Нема управљаних уређаја — најпре региструјте NIC, све се гради на матичним подацима',
    inventoryTitle: 'Посматрани уређаји',
    inventorySubtitle: 'Освежава их worker чвора при сваком пролазу усаглашавања — валидација проверава имена уређаја у односу на овај инвентар',
    colDevice: 'Уређај',
    colType: 'Тип',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Брзина',
    colTopology: 'Топологија',
    colMtu: 'MTU',
    colAddresses: 'Адресе',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP не агрегира',
    noInventory: 'До сада није пријављен ниједан уређај',
    interfacesTitle: 'Интерфејси',
    interfacesSubtitle: 'L3 конфигурација регистрованих NIC-ова и декларисаних логичких уређаја — set-if замењује цео блок, edit-if крпи својства, clear-if га празни (експлицитно чишћење)',
    colConfig: 'Жељена конфигурација',
    clean: 'чист',
    setIf: 'Измени адресирање',
    setIfTitle: 'Измените адресирање (set-if)',
    editIf: 'Измени својства',
    editIfTitle: 'Измените својства (edit-if)',
    clearIf: 'Испразни конфигурацију',
    clearIfTitle: 'Испразните конфигурацију (clear-if)',
    clearIfConfirm: 'Конфигурација интерфејса се празни. Чист интерфејс је предуслов да би се подредио као члан bonda/bridgea или VLAN parent.',
    ip4Mode: 'IPv4 режим',
    ip6Mode: 'IPv6 режим',
    modeUnconfigured: 'Неконфигурисан',
    modeStatic: 'Статички',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 адресе',
    ip6Addresses: 'IPv6 адресе',
    addressesHint: 'CIDR, одвојено зарезом',
    gw4: 'IPv4 gateway',
    gw6: 'IPv6 gateway',
    dns: 'DNS сервери',
    dnsHint: 'одвојено зарезом — празно брише DNS (set-if замењује блок)',
    routes4: 'IPv4 статичке руте',
    routes6: 'IPv6 статичке руте',
    routeTo: 'Одредиште (CIDR)',
    routeVia: 'Преко',
    addRoute: 'Додај руту',
    routesChip: 'руте',
    mtu: 'MTU',
    mtuHint: 'празно = подразумевано за driver',
    vlansTitle: 'VLAN-ови',
    addVlan: 'Додај VLAN',
    addVlanTitle: 'Додајте VLAN (add-vlan)',
    delVlanTitle: 'Обришите VLAN (del-vlan)',
    vlanParent: 'Parent интерфејс',
    vlanId: 'VLAN ID',
    vlanPreview: 'Име уређаја',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ниједан VLAN није декларисан',
    bondsTitle: 'Bondovi',
    addBond: 'Додај bond',
    addBondTitle: 'Додајте bond (add-bond)',
    editBondTitle: 'Измените bond',
    editBond: 'Сачувај bond',
    delBondTitle: 'Обришите bond (del-bond)',
    bondName: 'Име bonda',
    members: 'Чланови',
    membersHint: 'чланови морају бити чисти интерфејси (без L3 конфигурације)',
    bondMode: 'Режим',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Примарни члан',
    rate: 'LACP rate',
    hash: 'Политика hasha при слању',
    colMembers: 'Чланови',
    colMode: 'Режим',
    noBonds: 'Ниједан bond није декларисан',
    bridgesTitle: 'Bridgeovi',
    addBridge: 'Додај bridge',
    addBridgeTitle: 'Додајте bridge (add-bridge)',
    editBridgeTitle: 'Измените bridge',
    editBridge: 'Сачувај bridge',
    delBridgeTitle: 'Обришите bridge (del-bridge)',
    bridgeName: 'Име bridgea',
    stp: 'STP',
    stpOn: 'STP укључен',
    stpOff: 'STP искључен',
    colStp: 'STP',
    noBridges: 'Ниједан bridge није декларисан',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Постави hostname',
    setHostnameTitle: 'Поставите hostname (set-hostname)',
    hostnameHint: 'Само идентитет OS-а — име чвора у кластеру се не dira',
    notSet: 'није постављен',
    staticHostsTitle: 'Статичке хост ставке',
    addStaticHost: 'Додај ставку',
    addStaticHostTitle: 'Додајте статичку хост ставку',
    delStaticHostTitle: 'Обришите статичку хост ставку',
    hostIp: 'IP адреса',
    hostNames: 'Имена',
    hostNamesHint: 'одвојено зарезом или размаком',
    colIp: 'IP',
    colNames: 'Имена',
    noStaticHosts: 'Нема статичких хост ставки',
    delConfirm: 'Уклањање {name} из жељеног документа — worker чвора конвергира уз NetworkManager checkpoint и аутоматски rollback.',
    remove: 'Уклони',
    opError: 'Мрежна операција је одбијена'
  }
}
